/* eslint-disable @typescript-eslint/no-explicit-any */

import { memo, type FunctionComponent } from 'react';

import Close from '@mui/icons-material/Close';
import cx from 'classnames';

import { IAudioPlayerColors, Icons } from '../types';

// TODO: Restore makeStyles functionality

interface IAudioPlayControlProps {
    playerColors: IAudioPlayerColors;
    onClose: () => void;
    icons?: Icons;
    classNames?: any;
}

const AudioPlayCloseButton: FunctionComponent<IAudioPlayControlProps> = ({
    onClose,
    icons = {},
    classNames = {},
}) => {
    const { CloseIcon = Close } = icons;
    // const classes = useComponentStyles({ playerColors });
    return <CloseIcon onClick={onClose} className={cx(classNames.closeIcon)} />;
};

export default memo(AudioPlayCloseButton);
